/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Opening_PortalInputs */



/**
* | output |
* | --- |
* | "Opening portal..." |
*
* @param {Payment_Opening_PortalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const payment_opening_portal = /** @type {((inputs?: Payment_Opening_PortalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Opening_PortalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Portal wird geöffnet…")
	return /** @type {LocalizedString} */ ("Opening portal...")
});